import { Component, ElementRef, EventEmitter, Output, ViewChild, OnInit } from '@angular/core';

import { ButtonLoader } from '../../../../../../core';
import { ClienteCentralCompraFormComponent } from '../cliente-central-compra-form.component';
import { ClienteCentralCompra } from '../../cliente-central-compra';

@Component({
    selector: 'sgt-cliente-central-compra-form-modal',
    templateUrl: './cliente-central-compra-form-modal.component.html',
    styleUrls: ['./cliente-central-compra-form-modal.component.less']
})
export class ClienteCentralCompraFormModalComponent implements OnInit {
    elModal: any;
    @ViewChild('modal', {static: true}) modal: ElementRef;
    @ViewChild('form') form: ClienteCentralCompraFormComponent;

    @Output() afterSave = new EventEmitter<ClienteCentralCompra>();

    constructor() { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.modal?.nativeElement) as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    /** Abre o modal para editar uma central de compras */
    edit(id: number) {
        this.elModal.modal({keyboard: false, backdrop: 'static'});
        this.form?.edit(id);
    }

    /** Limpa as variáveis do modal */
    private clear() {
        this.form?.clear();
    }

    /** Fecha o modal */
    private close() {
        this.elModal.modal('hide');
        this.clear();
    }

    cancel() {
        this.close();
    }

    /** Salva a central de compras */
    save() {
        const btn = new ButtonLoader('#btnSaveCentralCompra');
        btn.loading('Salvando');
        this.form?.save()
            .then(() => {
                this.afterSave.emit(this.form.centralCompras);
                btn.reset();
                this.close();
            })
            .catch(() => {
                btn.reset();
            });
    }
}
